module.exports = __webpack_public_path__ + "static/img/no-act.2729d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-act.png
// module id = xmt2
// module chunks = 2